<script>
  // @ts-nocheck

  import { page } from '$app/stores';
  import GenericError from '$lib/components/GenericError.svelte';
  import NotFoundError from '$lib/components/NotFoundError.svelte';
  import NotAvailableForFreeUsers from '$lib/components/NotAvailableForFreeUsers.svelte';
</script>

{#if $page.status === 429}
  <NotAvailableForFreeUsers />
{:else if $page.status === 404}
  <NotFoundError />
{:else}
  <GenericError code={$page.status} message={$page.error.message} />
{/if}
